import { render } from "./TripPageLayout.vue?vue&type=template&id=abe00ec4"
import script from "./TripPageLayout.vue?vue&type=script&lang=ts"
export * from "./TripPageLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script